'use strict';
angular.module('distribution', []).controller('distributionCtrl', distributionCtrl);
distributionCtrl.inject = [
    '$scope',
    '$timeout',
    'editingCenterService',
    '$modalInstance',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
    'shareParams',
    '$filter',
    '$q',
    'trsColumnTreeLocationService',
    'iWoSbumitService',
];

/**
 * [多元分发控制器]
 */
function distributionCtrl(
    $scope,
    $timeout,
    editingCenterService,
    $modalInstance,
    trsHttpService,
    trsspliceString,
    modalDialog,
    shareParams,
    $filter,
    $q,
    trsColumnTreeLocationService,
    iWoSbumitService,
) {
    initStatus();
    initData();

    /**
     * [initStatus description] 初始化状态
     */
    function initStatus() {
        $scope.cur = {
            medias: iWoSbumitService.initMediaName(),
            // medias: [],
            currMedia: '',
        };
        $scope.data = {
            website: {
                lists: [], // 网站
                selectedItem: '',
            },
            appSite: {
                lists: [], // 客户端
                selectedItem: '',
            },
            newspaper: {
                lists: [], // 纸媒
                selectedItem: '',
            },
            weixin: {
                lists: [], // 微信
                selectedItem: '',
            },
            weibo: {
                lists: [], // 微博
                selectedItem: '',
            },
            douyin: {
                lists: [], // 抖音
                selectedItem: '',
            },
            baijiahao: {
                lists: [], // 百家号
                selectedItem: '',
            },
            qiehao: {
                lists: [], // 企鹅号
                selectedItem: '',
            },
            toutiaohao: {
                lists: [], // 头条号
                selectedItem: '',
            },
            kuaishou: {
                lists: [], // 快手
                selectedItem: '',
            },
            selectedNode: {}, // 树结构上被选中的节点
            appSelectedNode: {},
            app: {
                columns: [], // 栏目
            },
            hasSelectedCHANNELIDs: {},
            operBtns: [
                {
                    title: '签到待审',
                    class: 'confirm',
                    oper: 'signToPending',
                },
                {
                    title: '直接签发',
                    class: 'confirm',
                    oper: 'directSign',
                },
                {
                    title: '取消',
                    class: 'cancel',
                    oper: 'closeModal',
                },
            ],
        };
        $scope.status = {
            treeOptions: initTreeOpition(), // 网站树配置
            selectedArr: {
                // 各渠道下被选中的集合
                website: {},
                app: {},
                newspaper: [],
                weixin: [],
                weibo: [],
                douyin: [],
                baijiahao: [],
                qiehao: [],
                toutiaohao: [],
                kuaishou: []
            },
            showWebsite: false,
            showApp: false,
            showNewspaper: false,
            showWeixin: false,
            showWeibo: false,
            showDouyin: false,
            showBaijiahao: false,
            showQiehao: false,
            showToutiaohao: false,
            showKuaishou: false
        };
        $scope.path = {
            appSitePath: [],
            websitePath: [],
            newspaperPath: [],
            weixinPath: [],
            weiboPath: [],
            douyinPath: [],
            baijiahaoPath: [],
            qiehaoPath: [],
            toutiaohaoPath: [],
            kuaishouPath: []
        };
        $scope.windowTitle = '多元分发';
    }

    /**
     * [initData description] 初始化数据
     */
    function initData() {
        getWebsitesByDocIds();
        filterMedia();
        getChannelTree();
    }

    /**
     * [过滤可用渠道]
     */
    function filterMedia() {
        let medias = [];
        angular.forEach($scope.cur.medias, function(media, index) {
            if (media.siteKey) {
                medias.push(media);
            }
        });
        $scope.cur.medias = medias;
        $scope.cur.currMedia = $scope.cur.medias[0];
    }


    /** 获取可多元分发的站点
     * [getWebsitesByDocIds description]
     * @return {[type]} [description]
     */
    function getWebsitesByDocIds() {
        shareParams.mediaData.forEach(function(item, index) {
            dealMedia(item);
        });
    }

    /**
     * [dealMedia 处理可用渠道]
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    function dealMedia(item) {
        let siteKey = getSiteKey(item.MEDIATYPE);
        let mediaShowKey = getMediaShowKey(item.MEDIATYPE);
        let siteNameKey = getSiteNameKey(item.MEDIATYPE);
        let siteIDKey = getSiteIDKey(item.MEDIATYPE);
        $scope.status[mediaShowKey] = true;
        angular.forEach($scope.cur.medias, function(media, index) {
            if (media.mediaType == item.MEDIATYPE) {
                $scope.cur.medias[index].siteKey = siteKey;
            }
        });
        item.SITES.forEach(function(item1) {
            let obj = {};
            obj.SITEDESC = item1[siteNameKey];
            obj.SITEID = item1[siteIDKey];
            if (!(item.MEDIATYPE === shareParams.data[0].MEDIATYPE && item1[siteIDKey] === shareParams.data[0][siteIDKey])) {
                $scope.data[siteKey].lists.push(obj);
            }
        });
        if ($scope.data[siteKey].lists.length) {
            $scope.data[siteKey].selectedItem = $scope.data[siteKey].lists[0];
        }
    }

    /**
     * [getSiteNameKey 根据渠道ID获取频道名称键名]
     *
     * @param   {[type]}  mediaType  [mediaType description]
     *
     * @return  {[type]}             [return description]
     */
    function getSiteNameKey(mediaType) {
        return {
            1: 'SITEDESC',
            2: 'SITEDESC',
            4: 'CHNLDESC',
            5: 'ACCOUNTNAME',
            17: 'ACCOUNTNAME',
            18: 'ACCOUNTNAME',
            19: 'ACCOUNTNAME',
            20: 'CHNLDESC',
            25: 'ACCOUNTNAME'
        }[parseInt(mediaType)];
    }

    /**
     * [getSiteIDKey 根据渠道ID获取频道ID键名]
     *
     * @param   {[type]}  mediaType  [mediaType description]
     *
     * @return  {[type]}             [return description]
     */
    function getSiteIDKey(mediaType) {
        return {
            1: 'SITEID',
            2: 'SITEID',
            4: 'CHANNELID',
            5: 'CHANNELID',
            17: 'CHANNELID',
            18: 'CHANNELID',
            19: 'CHANNELID',
            20: 'CHANNELID',
            25: 'CHANNELID'
        }[parseInt(mediaType)];
    }

    /**
     * [getMediaName 根据渠道ID获取渠道名称]
     *
     * @param   {[type]}  mediaType  [mediaType 渠道ID]
     *
     * @return  {[type]}             [return description]
     */
    function getMediaName(mediaType) {
        return {
            1: '客户端',
            2: '网站',
            3: '纸媒',
            4: '微信',
            5: '微博',
            17: '抖音',
            18: '百家号',
            19: '企鹅号',
            20: '头条号',
        }[parseInt(mediaType)];
    }

    /**
     * [getSiteKey 根据渠道ID获取渠道频道列表键]
     *
     * @param   {[type]}  mediaType  [mediaType 渠道ID]
     *
     * @return  {[type]}             [return description]
     */
    function getSiteKey(mediaType) {
        return {
            1: 'appSite',
            2: 'website',
            3: 'newspaper',
            4: 'weixin',
            5: 'weibo',
            17: 'douyin',
            18: 'baijiahao',
            19: 'qiehao',
            20: 'toutiaohao',
            25: 'kuaishou'
        }[parseInt(mediaType)];
    }

    /**
     * [getMediaShowKey 根据渠道ID获取是否显示渠道频道列表的KEY]
     *
     * @param   {[type]}  mediaType  [mediaType 渠道ID]
     *
     * @return  {[type]}             [return description]
     */
    function getMediaShowKey(mediaType) {
        return {
            1: 'showApp',
            2: 'showWebsite',
            3: 'showNewspaper',
            4: 'showWeixin',
            5: 'showWeibo',
            17: 'showDouyin',
            18: 'showBaijiahao',
            19: 'showQiehao',
            20: 'showToutiaohao',
            25: 'showKuaishou'
        }[parseInt(mediaType)];
    }

    /** 查询可传稿的栏目树
     * [getChannelTree description]
     * @return {[type]} [description]
     */
    function getChannelTree() {
        if ($scope.cur.currMedia.mediaType !== 1 && $scope.cur.currMedia.mediaType !== 2) {
            return;
        }
        if (($scope.cur.currMedia.mediaType === 1 && !$scope.data.appSite.lists.length) || ($scope.cur.currMedia.mediaType === 2 && !$scope.data.website.lists.length)) {
            modalDialog.alertType('','当前渠道没有可供多元分发的站点','error', false);
            return;
        }
        var params = {
            serviceid: 'mlf_transmitdoc',
            methodname: 'getChannelTree',
            SiteId: $scope.cur.currMedia.mediaType == 1 ? $scope.data.appSite.selectedItem.SITEID : $scope.data.website.selectedItem.SITEID,
            DocIds: shareParams.data
                .map((item) => item.METADATAID)
                .join(','),
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            let obj = {};
            obj.CHILDREN = data;
            if ($scope.cur.currMedia.mediaType === 1) {
                $scope.data.app.columns = obj;
            } else if ($scope.cur.currMedia.mediaType === 2) {
                $scope.data.website.columns = obj;
            }
        });
    }

    /**
     * [selectSite description]点击网站或APP选择栏目
     * @param  {[obj]} site [description]当前站点信息
     * @return {[type]}      [description]
     */
    $scope.selectSite = function(site, type) {
        if (type == 'website') {
            $scope.data.expandedTest = [];
            $scope.data.website.selectedItem = site;
            $scope.status.scalingMenu = true;
            $scope.data.channelFilter = '';
            getChannelTree();
        } else if (type == 'appSite') {
            $scope.data.appExpandedTest = [];
            $scope.data.appSite.selectedItem = site;
            $scope.status.scalingMenu = true;
            $scope.data.appChannelFilter = '';
            getChannelTree();
        } else {
            let path = {
                mediaName: getMediaNameByType(type),
                channelName: site.SITEDESC,
                siteId: site.SITEID,
            };
            if (notExists($scope.path[type + 'Path'], path)) {
                $scope.path[type + 'Path'].push(path);
                $scope.status.selectedArr[type].push(path);
            }else {
                $scope.path[type + 'Path'].splice($scope.path[type + 'Path'].indexOf(path, 1));
                $scope.status.selectedArr[type].splice($scope.status.selectedArr[type].indexOf(path, 1));
            }
        }
    };

    /**
     * [notExists 判断频道/栏目是否已经选中]
     *
     * @param   {[type]}  arr   [arr description]
     * @param   {[type]}  path  [path description]
     *
     * @return  {[type]}        [return description]
     */
    function notExists(arr, path) {
        let rs = true;
        angular.forEach(arr, function(item) {
            if (item.siteId === path.siteId) {
                rs = false;
            }
        });
        return rs;
    }

    /**
     * [isExists description]挂载到scope上
     *
     * @param   {[type]}  item   [arr description]
     * @return  {[type]}        [return description]
     */
    $scope.isExists = function (site, type) {
        let path = {
            mediaName: getMediaNameByType(type),
            channelName: site.SITEDESC,
            siteId: site.SITEID,
        };
        return !notExists($scope.path[type + 'Path'], path);
    };
    /**
     * [getMediaNameByType 根据渠道类型标识获取渠道名称]
     *
     * @param   {[type]}  type  [type 渠道类型标识]
     *
     * @return  {[type]}        [return description]
     */
    function getMediaNameByType(type) {
        return {
            'newspaper': '纸媒',
            'weixin': '微信',
            'weibo': '微博',
            'douyin': '抖音',
            'baijiahao': '百家号',
            'qiehao': '企鹅号',
            'toutiaohao': '头条号',
            'kuaishou': '快手'
        }[type];
    }

    // 点击一级站点
    $scope.setCurrMedia = function(media, index) {
        $scope.cur.currMedia = media;
        getChannelTree();
    };

    /** 组织树配置
     * [initTreeOpition description]
     * @return {[type]} [description]
     */
    function initTreeOpition() {
        var treeOptions = {
            nodeChildren: 'CHILDREN',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
            isLeaf: function(node) {
                return node.HASCHILDREN == 'false';
            },
        };
        return treeOptions;
    }

    $scope.getChannel = function(node) {
        let obj = {};
        obj.CHANNELID = node.CHANNELID;
        obj.CHNLNAME = node.CHNLDESC;
        obj.siteName = $scope.data.appSite.selectedItem.SITEDESC;
        obj.siteId = $scope.data.appSite.selectedItem.SITEID;

        // 判断对象是否为空
        function isEmptyObject(e) {
            var t;
            for (t in e) {
                return !1;
            }
            return !0;
        }

        if (isEmptyObject($scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID])) {
            $scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID] = obj;
        } else {
            if (obj.CHANNELID == $scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID].CHANNELID) {
                $scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID] = {};
            } else {
                $scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID] = obj;
            }
        }
        $scope.path.appSitePath = []; // 重置

        for (var i in $scope.status.selectedArr.app) {
            if (!$scope.status.selectedArr.app[i].CHNLNAME) {
                continue;
            }
            let pathObj = {};
            pathObj.mediaName = '客户端';
            pathObj.siteId = $scope.status.selectedArr.app[i].siteId;
            pathObj.siteName = $scope.status.selectedArr.app[i].siteName;
            pathObj.channelName = $scope.status.selectedArr.app[i].CHNLNAME;
            pathObj.CHANNELID = $scope.status.selectedArr.app[i].CHANNELID;
            $scope.path.appSitePath.push(pathObj);
        }
    };

    $scope.getChannelWeb = function(node) {
        let obj = {};
        obj.CHANNELID = node.CHANNELID;
        obj.CHNLNAME = node.CHNLDESC;
        obj.siteName = $scope.data.website.selectedItem.SITEDESC;
        obj.siteId = $scope.data.website.selectedItem.SITEID;

        // 判断对象是否为空
        function isEmptyObject(e) {
            var t;
            for (t in e) {
                return !1;
            }
            return !0;
        }

        if (isEmptyObject($scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID])) {
            $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID] = obj;
        } else {
            if (obj.CHANNELID == $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID].CHANNELID) {
                $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID] = {};
            } else {
                $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID] = obj;
            }
        }
        $scope.path.websitePath = []; // 重置

        for (var i in $scope.status.selectedArr.website) {
            if (!$scope.status.selectedArr.website[i].CHNLNAME) {
                continue;
            }
            let pathObj = {};
            pathObj.mediaName = '网站';
            pathObj.siteId = $scope.status.selectedArr.website[i].siteId;
            pathObj.siteName = $scope.status.selectedArr.website[i].siteName;
            pathObj.channelName = $scope.status.selectedArr.website[i].CHNLNAME;
            pathObj.CHANNELID = $scope.status.selectedArr.website[i].CHANNELID;
            $scope.path.websitePath.push(pathObj);
        }
    };

    /** 删除路径
     * [deleteTrack description]
     * @param  {[type]} index [description]
     * @param  {[type]} path  [description]
     * @param  {[type]} way   [description]
     * @return {[type]}       [description]
     */
    $scope.deleteTrack = function(index, path) {
        let way = '';
        $scope.cur.medias.map((item) => {
            if (item.mediaName == path.mediaName) {
                way = item.siteKey;
                if (item.siteKey == 'appSite') {
                    way = 'app';
                }
            }
        });
        if (way == 'app') {
            $scope.path.appSitePath.splice(index, 1);
            $scope.status.selectedArr.app[path.siteId] = {};
        } else if (way == 'website') {
            $scope.path.websitePath.splice(index, 1);
            $scope.status.selectedArr.website[path.siteId] = {};
        } else {
            $scope.path[way + 'Path'].splice(index, 1);
            $scope.status.selectedArr[way].splice(index, 1);
        }
    };

    /**
     *[getSuggestions description]搜索栏目
     * @param  {[type]}channelname  [description] 输入栏目名称
     * return {[type]}   null  [description]
     */
    var promise;
    $scope.getSuggestions = function(channelName, type) {
        if (channelName === '') {
            return;
        }
        if (promise) {
            $timeout.cancel(promise);
            promise = null;
        }
        var siteid = type == 'website' ? $scope.data.website.selectedItem.SITEID : $scope.data.appSite.selectedItem.SITEID;
        promise = $timeout(function() {
            var params = {
                serviceid: 'mlf_transmitdoc',
                methodname: 'getChannelPaths',
                ChannelName: channelName,
                SiteId: siteid,
                DocIds: shareParams.data
                    .map((item) => item.METADATAID)
                    .join(','),
            };
            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (!data) {
                    return data;
                }
                var arr = [];
                for (var i in data) {
                    let obj = {};
                    obj.CHANNELID = i;
                    obj.SUGGESTION = data[i];
                    arr.push(obj);
                }
                return arr;
            });
        }, 500);
        return promise;
    };
    $scope.$watch('data.appChannelFilter', function(newValue, oldValue) {
        if (angular.isObject(newValue)) {
            // 初始化树数据
            getChannelTree();
            // getAppColumn($scope.data.app.selectedItem);
            // 清空树展开
            $scope.data.appExpandedTest = [];
            // 重新定位树展开位置
            // getPositionData(newValue.CHANNELID);
            trsColumnTreeLocationService.columnTreeLocation(
                1,
                newValue.CHANNELID,
                $scope.data.app.columns,
                $scope.data.appSelectedNode,
                $scope.data.appExpandedTest,
                function(tree, array) {
                    delete $scope.data.app.columns;
                    $scope.data.app.columns = tree;
                    // $scope.status.selectedArr.app[$scope.data.app.selectedItem.SITEID] = array.pop();
                    let obj = {
                        CHANNELID: newValue.CHANNELID,
                    };
                    let arr = newValue.SUGGESTION.split('>');
                    obj.CHNLNAME = arr[arr.length - 1];
                    obj.siteName = $scope.data.appSite.selectedItem.SITEDESC;
                    obj.siteId = $scope.data.appSite.selectedItem.SITEID;
                    $scope.status.selectedArr.app[$scope.data.appSite.selectedItem.SITEID] = obj;
                    $scope.path.appSitePath = []; // 重置
                    for (var i in $scope.status.selectedArr.app) {
                        if (!$scope.status.selectedArr.app[i].CHNLNAME) {
                            continue;
                        }
                        let pathObj = {};
                        pathObj.mediaName = '客户端';
                        pathObj.siteId = $scope.status.selectedArr.app[i].siteId;
                        pathObj.siteName = $scope.status.selectedArr.app[i].siteName;
                        pathObj.channelName = $scope.status.selectedArr.app[i].CHNLNAME;
                        pathObj.CHANNELID = $scope.status.selectedArr.app[i].CHANNELID;
                        $scope.path.appSitePath.push(pathObj);
                    }
                },
            );
        }
    });
    $scope.$watch('data.channelFilter', function(newValue, oldValue) {
        if (angular.isObject(newValue)) {
            // 初始化树数据
            getChannelTree();
            // getAppColumn($scope.data.app.selectedItem);
            // 清空树展开
            $scope.data.appExpandedTest = [];
            // 重新定位树展开位置
            // getPositionData(newValue.CHANNELID);
            trsColumnTreeLocationService.columnTreeLocation(
                7,
                newValue.CHANNELID,
                $scope.data.website.columns,
                $scope.data.selectedNode,
                $scope.data.expandedTest,
                function(tree, array) {
                    delete $scope.data.website.columns;
                    $scope.data.website.columns = tree;
                    // $scope.status.selectedArr.app[$scope.data.app.selectedItem.SITEID] = array.pop();
                    let obj = {
                        CHANNELID: newValue.CHANNELID,
                    };
                    let arr = newValue.SUGGESTION.split('>');
                    obj.CHNLNAME = arr[arr.length - 1];
                    obj.siteName = $scope.data.website.selectedItem.SITEDESC;
                    obj.siteId = $scope.data.website.selectedItem.SITEID;
                    $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID] = obj;
                    $scope.path.websitePath = []; // 重置
                    for (var i in $scope.status.selectedArr.website) {
                        if (!$scope.status.selectedArr.website[i].CHNLNAME) {
                            continue;
                        }
                        let pathObj = {};
                        pathObj.mediaName = '网站';
                        pathObj.siteId = $scope.status.selectedArr.website[i].siteId;
                        pathObj.siteName = $scope.status.selectedArr.website[i].siteName;
                        pathObj.channelName = $scope.status.selectedArr.website[i].CHNLNAME;
                        pathObj.CHANNELID = $scope.status.selectedArr.website[i].CHANNELID;
                        $scope.path.websitePath.push(pathObj);
                    }
                },
            );
        }
    });

    /** 签到待审
     * [pending description]
     * @return {[type]} [description]
     */
    $scope.pending = function() {
    };

    /** 直接签发
     * [sign description]
     * @return {[type]} [description]
     */
    $scope.sign = function(type) {
        mutilSign(type);
        // if (shareParams.mediaType === '1') {
        //     mutilSign(type);
        // } else {
        //     sign(type);
        // }
    };

    function directSign() {
        $scope.sign();
    }

    function signToPending() {
        $scope.sign('noSign');
    }

    /**
     * [sign 旧的多元签发逻辑]
     *
     * @param   {[type]}  type  [type description]
     *
     * @return  {[type]}        [return description]
     */
    function sign(type) {
        let arr = [];
        for (var i in $scope.path) {
            for (var j = 0; j < $scope.path[i].length; j++) {
                arr.push($scope.path[i][j].CHANNELID);
            }
        }

        var params = {
            serviceid: 'mlf_transmitdoc',
            methodname: shareParams.type, //
            DocIds: shareParams.data
                .map((item) => item.METADATAID)
                .join(','),
            Publish: type != 'noSign',
            ChnlIds: arr
                .map((item) => item)
                .join(','),
        };

        if (!params.ChnlIds) {
            modalDialog.alertType('请先选择渠道', '', 'info', false);
            return;
        }

        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            dealResult(type, data);
        });
    }

    /**
     * [mutilSign 多元签发新接口]
     *
     * @param   {[type]}  type  [type description]
     *
     * @return  {[type]}        [return description]
     */
    function mutilSign(type) {
        let appChannelIds = Object.values($scope.status.selectedArr['app'])
            .map((item) => item.CHANNELID)
            .join(',');
        let websiteChannelIds = Object.values($scope.status.selectedArr['website'])
            .map((item) => item.CHANNELID)
            .join(',');
        let weixinChannelIds = $scope.status.selectedArr['weixin']
            .map((item) => item.siteId)
            .join(',');
        let weiboChannelIds = $scope.status.selectedArr['weibo']
            .map((item) => item.siteId)
            .join(',');
        let baijiahaoChannelIds = $scope.status.selectedArr['baijiahao']
            .map((item) => item.siteId)
            .join(',');
        let douyiinChannelIds = $scope.status.selectedArr['douyin']
            .map((item) => item.siteId)
            .join(',');
        let qiehaoChannelIds = $scope.status.selectedArr['qiehao']
            .map((item) => item.siteId)
            .join(',');
        let toutiaohaoChannelIds = $scope.status.selectedArr['toutiaohao']
            .map((item) => item.siteId)
            .join(',');
        let kuaishouChannelIds = $scope.status.selectedArr['kuaishou']
            .map((item) => item.siteId)
            .join(',');
        let params = {
            serviceid: 'mlf_transmitdoc',
            methodname: shareParams.type,
            docIds: shareParams.data
                .map((item) => item.METADATAID)
                .join(','),
            isPublish: type !== 'noSign',
            MlfApp: appChannelIds,
            Web: websiteChannelIds,
            weChat: weixinChannelIds,
            MicroBlog: weiboChannelIds,
            baijiahao: baijiahaoChannelIds,
            tiktok: douyiinChannelIds,
            kuaibao: qiehaoChannelIds,
            Toutiao: toutiaohaoChannelIds,
            kuaishou: kuaishouChannelIds
        };
        if (!params.MlfApp && !params.Web && !params.weChat && !params.MicroBlog && !params.baijiahao && !params.tiktok && !params.kuaibao && !params.Toutiao && !params.kuaishou) {
            modalDialog.alertType('请先选择渠道', '', 'info', false);
            return;
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            dealResultForMutilSign(type, data);
        });
    }

    /**
     * [dealResult 处理签发结果]
     *
     * @param   {[type]}  type  [data description]
     * @param   {[type]}  data  [data description]
     *
     * @return  {[type]}        [return description]
     */
    function dealResult(type, data) {
        if (data.APPFAIL == 'false' && data.WEBSITEFAIL == 'false') {
            let str = type == 'noSign' ? '送审成功' : '签发成功';
            modalDialog.alertType('', str, 'success', false, function() {
                $modalInstance.close('success');
            });
        } else {
            editingCenterService.infoAlert(data, function() {
                $modalInstance.close('success');
            });
        }
    }

    /**
     * [dealResultForMutilSign description]
     *
     * @param   {[type]}  type  [data description]
     * @param   {[type]}  data  [data description]
     *
     * @return  {[type]}        [return description]
     */
    function dealResultForMutilSign(type, data) {
        if (angular.isDefined(data.ISSUCCESS) && data.ISSUCCESS === 'true') {
            let str = type == 'noSign' ? '送审成功' : '签发成功';
            modalDialog.alertType('', str, 'success', false, function() {
                $modalInstance.close('success');
            });
        }
    }

    /**
     * [关闭]
     */
    $scope.close = function() {
        closeModal();
    };

    /**
     * [关闭弹窗]
     */
    function closeModal() {
        $modalInstance.dismiss();
    }

    $scope.isShowMedia = function(media) {
        let mediaShowKey = getMediaShowKey(media.mediaType);
        return $scope.status[mediaShowKey];
    };

    $scope.hasContop = function(media) {
        return media.mediaType < 4;
    };

    $scope.hasConRight = function(media) {
        return media.mediaType < 4;
    };

    $scope.btnOper = function(btn) {
        eval(btn.oper + '()');
    };


}
